import { Navigate } from "react-router-dom";
import { getFromStorage } from "../helpers";
import { STORAGE_KEYS } from "../helpers";

const ProtectedRoutes = ({ children }: any) => {
  if (getFromStorage(STORAGE_KEYS.token)) {
    return children;
  }
  return <Navigate to="/" replace />;
};

export default ProtectedRoutes;
